;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import Image from "next/image"
import Link from "next/link"
// import Grid from "@mui/material/Grid"
import descriptionWithNewLines from "../../../../lib/formatter/descriptionWithNewLines"
// const NO_UPCOMING_COHORT_ANNOUNCEMENT = "No upcoming cohort announcement"
const NO_DESCRIPTION = "No group description added"
export default function ImageMetaDataDescriptionTags({
  group,
  // groupScheduleBlurb,
  // groupType,
  groupTags,
  // firstCohortSessionInfo,
}) {
  // const remainingSessionDateCount = firstCohortSessionInfo?.remainingSessionDateCount

  const renderGroupImage = () => {
    const src = group?.photoUrl

    return (
      <div className={"flex w-full justify-center pt-[20px]"} key={"group-image"}>
        <div
          className={
            "rounded-[4px] relative w-full h-full z-index-[10] max-w-[302px] max-h-[178px] min-[900px]:max-w-[536px] min-[900px]:max-h-[315px] aspect-17/10"
          }
        >
          {src ? (
            <Image
              src={src}
              alt={"group photo"}
              fill={true}
              sizes="(min-width: 900px) 536px, 100vw"
              style={{
                objectFit: "cover",
                overflow: "hidden",
                borderRadius: "12px",
              }}
              priority={true}
            />
          ) : null}
        </div>
      </div>
    )
  }

  // const renderBlurb = () => {
  //   const groupTypeBlurbAndSessionsRemaining =
  //     groupType == null || remainingSessionDateCount == 0
  //       ? NO_UPCOMING_COHORT_ANNOUNCEMENT
  //       : `Upcoming ${groupType} ${remainingSessionDateCount > 1 ? "series" : ""}`
  //   return (
  //     <div
  //       className={
  //         "flex flex-col text-16px  min-[600px]:text-20px tracking-75 text-center my-[20px] min-[600px]:my-[30px] "
  //       }
  //       key={"blurb"}
  //     >
  //       <div
  //         className={`font-medium min-[600px]:font-bold ${groupTypeBlurbAndSessionsRemaining == NO_UPCOMING_COHORT_ANNOUNCEMENT ? "text-accent-red" : ""}`}
  //       >
  //         {groupTypeBlurbAndSessionsRemaining}
  //       </div>
  //       <div className={"mt-[10px] text-[#202020]"}>{groupScheduleBlurb}</div>
  //     </div>
  //   )
  // }

  const renderGroupShortDescription = () => {
    const description = group?.description || NO_DESCRIPTION
    return (
      <div
        className={`text-[17px] min-[600px]:text-18px leading-[25px] italic tracking-[0.08em] ${description == NO_DESCRIPTION ? "text-accent-red" : ""}`}
        key={"group-description"}
      >
        {description ? descriptionWithNewLines(description, "group-short-desc") : ""}
      </div>
    )
  }
  const renderTag = (tag, index, totalTags) => {
    return (
      <React.Fragment key={`tag-${index}`}>
        <Link
          href={`/?search=${encodeURIComponent(tag)}`}
          className="text-19px pt-[5px] pb-[2px] leading-[19px] tracking-[.05em] text-black font-bebas no-underline hover:underline"
        >
          {tag}
        </Link>
        {index < totalTags - 1 && (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="15"
            height="15"
            viewBox="0 0 15 15"
            fill="none"
            className="mx-4"
          >
            <circle cx="7.5" cy="7.5" r="7.5" fill="#092C3C" />
          </svg>
        )}
      </React.Fragment>
    )
  }
  const renderGroupTags = () => {
    return (
      <div className="flex justify-center my-[20px]" key="group-tags">
        <div className="bg-gray-bg-color rounded-[30px] py-1 px-6 flex items-center justify-center flex-wrap">
          {groupTags?.map((tag, index) => renderTag(tag, index, groupTags.length))}
        </div>
      </div>
    )
  }

  return [renderGroupImage(), renderGroupTags(), renderGroupShortDescription()]
}
